import { TaskStatus } from '@nexelem/graphne-api';
import { useKanbanFormatTaskDuration } from '../hooks';
import { clsx } from 'clsx';
import { useDateFormatter } from '@nexelem/utils';
import { useProductionPlanSettings } from '../../components/SettingsDrawer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDay, faIndustryWindows } from '@fortawesome/pro-light-svg-icons';

type KanbanTimeProps = {
  isOverdue?: boolean;
  start: string;
  end: string;
  status?: TaskStatus;
  dueDate?: string;
  className?: string;
};
export const KanbanTime = ({ isOverdue, start, end, status, dueDate, className }: KanbanTimeProps) => {
  const formatTaskDuration = useKanbanFormatTaskDuration();
  const format = useDateFormatter({ displayWithHours: true });
  const showTime = useProductionPlanSettings((state) => state.kanban.showOnTask.time);

  const duration = formatTaskDuration({ start, end });

  return (
    showTime && (
      <span
        className={clsx(
          'mt-1 flex flex-wrap justify-between gap-2 border-t border-border-primary pt-2 text-s11-sb',
          isOverdue ? 'text-surface-status-rose-darker' : 'text-text-secondary',
          'group-[.disabled]:text-text-disabled',
          className,
        )}
      >
        <span className="flex items-center gap-1">
          {dueDate && (
            <>
              <FontAwesomeIcon className="min-h-4 min-w-4" icon={faCalendarDay} />
              {format(dueDate)}
            </>
          )}
        </span>

        <span className="flex items-center gap-1">
          <FontAwesomeIcon className="min-h-4 min-w-4" icon={faIndustryWindows} />
          {status === TaskStatus.Pending && <span>~</span>}
          {duration}
        </span>
      </span>
    )
  );
};
